import React, { Fragment, useContext, useEffect, useState, useRef, memo, useCallback, useReducer } from "react";
import { AppContext } from "../../../components/AppProvider";
import { _O } from "../../../modules/utils";
import { ScrollToTop } from "../../common/ScrollToTop/ScrollToTop";
import { closeLayerFn, openAlertPopup, openLayerFn } from "../../Layout";
import LocationTerms from "./LocationTerms";
import PrivateTerms from "./PrivateTerms";
import ServiceTerms from "./ServiceTerms";
import { userHabit } from "../../../modules/utils/UserHabit";

export default (props) => {
    const {phonecfg} = useContext(AppContext);
    const agreeAll = () => {
        $(".all-check-box a").toggleClass("on");

        if($(".all-check-box a").attr("class") === "on") { 
            //해당화면에 전체 checkbox들을 체크해준다 
            $("input[type=checkbox]").prop("checked",true); 
            // 전체선택 체크박스가 해제된 경우 
        } else { 
            //해당화면에 모든 checkbox들의 체크를해제시킨다.
            $("input[type=checkbox]").prop("checked",false); 
        }
    }

    const closeTermsPopup = () => {
        // 초기화
        $(".all-check-box a").removeClass();
        $("input[type=checkbox]").prop("checked",false);

        closeLayerFn($("#termsPopup"));
        _O.Open("/membership/login");
    }

    const checkComplete = () => {
        if($("#serviceTerms").is(":checked") == false) {
            openAlertPopup("서비스 약관에 동의해 주세요.");
        } else if($("#privateTerms").is(":checked") == false) {
            openAlertPopup("개인정보 수집, 이용약관에 동의해 주세요.");
        } else if($("#locationTerms").is(":checked") == false) {
            openAlertPopup("위치기반서비스 이용약관에 동의해 주세요.");
        } else {
            closeLayerFn($("#termsPopup"));
            openLayerFn($("#authPopup"));
            userHabit(phonecfg, 'RG100_P02');
        }
    }

    const validateCheckBox = () => {
        if($("input[type=checkbox]:checked").length == $("input[type=checkbox]").length) {
            $(".all-check-box a").addClass("on");
        } else {
            $(".all-check-box a").removeClass();
        }
    }

    return(
        <div className="white-layer-box" id="termsPopup" style={{display:"none"}}>
            <div className="wlb-blind"></div>
            <div className="layer-wrap">
                <div className="incont">
                    <div className="tit">서비스 약관에 동의해 주세요.</div>
                    
                    <div className="all-check-box">
                        <a onClick={agreeAll}>모든 서비스 약관 동의</a>
                    </div>
                
                    <div className="terms-area">
                        <div>
                            <label className="check-box">
                                <input type="checkbox" id="serviceTerms" onChange={validateCheckBox}/><i></i>
                                서비스 이용약관 (필수)
                            </label>
                
                            <a className="btn-more" onClick={()=>openLayerFn($("#serviceViewer"))}>자세히 보기</a>
                        </div>
                        <div>
                            <label className="check-box">
                                <input type="checkbox" id="privateTerms" onChange={validateCheckBox}/><i></i>
                                개인정보 수집, 이용약관 (필수)
                            </label>
                            <p>고유식별 정보처리 동의 (필수)</p>
                            <p>통신사 이용약관 동의 (필수)</p>
                            <a className="btn-more" onClick={()=>openLayerFn($("#privateViewer"))}>자세히 보기</a>
                        </div>
                        <div>
                            <label className="check-box">
                                <input type="checkbox" id="locationTerms" onChange={validateCheckBox}/><i></i>
                                위치기반서비스 이용약관 (필수)
                            </label>
                            <a className="btn-more" onClick={()=>openLayerFn($("#locationViewer"))}>자세히 보기</a>
                        </div>
                        
                
                    </div>
                
                    <div className="bot-btn">
                        <a onClick={()=>closeTermsPopup()} className="gray">닫기</a>
                        <a onClick={()=>checkComplete()}>동의하기</a>
                    </div>
                </div>
            </div>
        </div>
    )
}

export const TermsLayerPopup = (props) => {
    const closeTermsPopup = () => {
        // 초기화
        $(".all-check-box a").removeClass();
        $("input[type=checkbox]").prop("checked",false);

        closeLayerFn($("#termsPopup"));
    }

    return(
        <div id="termsPopup" style={{display:"none", position:"absolute", zIndex:"100", background:"#fff", padding:"25px 20px", height:(screen.height-50), overflow:"none"}}>
            <a onClick={()=>closeTermsPopup()} className="btn-closex-white" style={{backgroundColor:"#000", opacity:"50%"}}></a>
            <div className="device-link-contain type4" style={{height:"100%", overflow:"auto"}}>
                {/* <div>
                    <div className="round-list">
                        <div className="title">
                            서비스 이용약관
                        </div>
                    </div>
                </div> */}

                <ServiceTerms />

                <PrivateTerms />

                <LocationTerms />

                {/* <div className="bot-btn">
                    <a onClick={()=>closeTermsPopup()} className="gray">닫기</a>
                </div> */}
            </div>
        </div>
    )
}